export const packNumericIds = (ids: number[]) => ids.join(',');

export const unpackNumericIds = (ids: string) => ids.split(',').map(Number);

/**
 * Selection ID parsing utilities for PO/TG hierarchical selections.
 *
 * In the Purchases time view, selection IDs have two formats:
 * - PO (Purchase Order) IDs: Simple numbers without commas (e.g., "12345")
 * - TG (Ticket Group) IDs: Packed format with comma (e.g., "12345,67890" = poId,tgId)
 */

/** Check if a selection ID is a PO ID (simple number without comma) */
export const isPoSelectionId = (id: string) =>
  !id.includes(',') && parseInt(id, 10) > 0;

/** Check if a selection ID is a TG ID (packed format with comma) */
export const isTgSelectionId = (id: string) => id.includes(',');

/** Parse a PO selection ID to numeric ID */
export const parsePoSelectionId = (id: string) => parseInt(id, 10);

/** Parse a TG selection ID to get parent PO ID and TG ID */
export const parseTgSelectionId = (
  id: string
): { poId: number; tgId: number } => {
  const [poId, tgId] = unpackNumericIds(id);
  return { poId, tgId };
};

/** Filter selection IDs to get only PO IDs */
export const filterPoSelectionIds = (ids: string[]) =>
  ids.filter(isPoSelectionId);

/** Filter selection IDs to get only TG IDs */
export const filterTgSelectionIds = (ids: string[]) =>
  ids.filter(isTgSelectionId);
